import styled from 'styled-components';

const SkipToContent = styled.a.attrs({
  id: 'skip-to-content',
  href: '#main',
})`
  padding: 1rem;
  position: absolute;
  top: -100px;
  left: 1rem;
  z-index: 10;
  background: #333;
  color: #fff;

  &:focus {
    position: absolute;
    top: 0;
  }
`;

export default SkipToContent;
